import { Body, MaterialIcon, Stack } from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';

const ErrorComponent = () => {
  const t = useTranslate();
  return (
    <Stack
      data-testid="update-application-error"
      spacing="xxl"
      align="center"
      justify="center"
      p="1.5em"
    >
      <MaterialIcon src="error" filled size="48" color="Icon/Danger" />
      <Body size="lg" data-record>
        {t('UpdateApplication.Error')}
      </Body>
    </Stack>
  );
};

export default ErrorComponent;
